export class ImportAccounts {
  public brandId: number;
  public fileId: string;
}
